import { body } from 'express-validator'

export const validateLogin = [
  body('username')
    .trim()
    .notEmpty()
    .isLength({ min: 3 })
    .withMessage('Username is required')
    .escape(),
  body('password')
    .trim()
    .notEmpty()
    .isLength({ min: 6 })
    .withMessage('Password is required')
    .escape(),
]
